module.exports = __webpack_public_path__ + "7dbff51a4b1dcc29e05675602b102a5e.fbx";